import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100px;
  margin-bottom: 24px;

  & > p {
    font-size: 12px;
  }
`;

export const EvLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;

  & > p {
    font-size: 12px;
  }
`;

export const EvWrapper = styled.div`
  display: flex;
`;

export const Value = styled.p`
  color: #183558;
  font-size: 24px;
  font-weight: bold;
  margin-left: auto;
`;

export const GreenValue = styled.p`
  color: var(--colors-primary-green-2);
  font-size: 16px;
  font-weight: bold;
  margin-left: auto;
`;

export const BoxTextRight = styled.p`
  font-size: 16px;
  margin-left: auto;
  color: #757989;
`;

export const DueAtOrderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 24px;
`;

export const PaymentBreakdownList = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px !important;
  gap: 4px;
`;

export const PaymentBreakdownShowHideWrapper = styled.div`
  display: flex;
  place-content: flex-end;
  color: #00aed9;
  font-size: 14px;
  cursor: pointer;
`;
